import crud from '@/store/crud';
import http from '@/http';

const crudStore = crud('measures');

// state
export const state = crudStore.state;

// mutations
export const mutations = crudStore.mutations;

// actions
export const actions = {
    ...crudStore.actions,
    publish({ commit, state: { measure: { id } } }) {
        return http.post(`/measures/${id}/publish`)
            .then(measure => {
                commit(crudStore.types.CRUD_SET_RESOURCE, measure);

                return measure;
            });
    },
    recommend({ commit, state: { measure: { id } } }) {
        return http.post(`/measures/${id}/recommend`)
            .then(measure => {
                commit(crudStore.types.CRUD_SET_RESOURCE, measure);

                return measure;
            });
    },
    retire({ commit, state: { measure: { id } } }) {
        return http.post(`/measures/${id}/retire`)
            .then(measure => {
                commit(crudStore.types.CRUD_SET_RESOURCE, measure);

                return measure;
            });
    },
    updatePricing({ state: { measure: { id } } }, pricing) {
        return http.patch(`measures/${id}/pricing`, pricing);
    },
    updateCustomerAccess({ state: { measure: { id } } }, customers) {
        return http.put(`measures/${id}/customer-access`, { customers });
    },
};

// getters
export const getters = {};
